import { apiReducer } from "@utils/reduxUtil";
import { MODULE_NAME } from "../constants";
import { TransactionsInitialStateInterface } from "../types";

const initialState: TransactionsInitialStateInterface = {
	updatePurchaseStatusStart: false,
	updatePurchaseStatusError: null,
	getDeliveryOrderUrl: {},
	getDeliveryOrderUrlStart: false,
	getDeliveryOrderUrlError: null,
	downloadPurchaseDocumentUrl: "",
	downloadPurchaseDocumentUrlStart: false,
	downloadPurchaseDocumentUrlError: null,
	uploadPurchaseDocumentUrl: {},
	uploadPurchaseDocumentUrlStart: false,
	uploadPurchaseDocumentUrlError: null,
};

const transactionsReducer = (state = initialState, action: any): TransactionsInitialStateInterface => {
	return (state = apiReducer(state, action, MODULE_NAME));
};

export default transactionsReducer;
